import script from "./ListCatalog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListCatalog.vue?vue&type=script&lang=ts&setup=true"

import "./ListCatalog.vue?vue&type=style&index=0&id=673df9da&lang=css"

const __exports__ = script;

export default __exports__